var _ObservableSet_observable;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
import Observable from './observable';
class ObservableSet extends Set {
    constructor(values) {
        super();
        _ObservableSet_observable.set(this, void 0);
        __classPrivateFieldSet(this, _ObservableSet_observable, new Observable(), "f");
        if (values)
            Array.from(values).forEach((value) => super.add(value));
    }
    add(value) {
        super.add(value);
        __classPrivateFieldGet(this, _ObservableSet_observable, "f").notify(this);
        return this;
    }
    addMany(values) {
        Array.from(values).forEach((value) => super.add(value));
        __classPrivateFieldGet(this, _ObservableSet_observable, "f").notify(this);
        return this;
    }
    delete(value) {
        const result = super.delete(value);
        __classPrivateFieldGet(this, _ObservableSet_observable, "f").notify(this);
        return result;
    }
    deleteMany(values) {
        Array.from(values).forEach((value) => super.delete(value));
        __classPrivateFieldGet(this, _ObservableSet_observable, "f").notify(this);
        return this;
    }
    clear() {
        super.clear();
        __classPrivateFieldGet(this, _ObservableSet_observable, "f").notify(this);
    }
    toArray() {
        return Array.from(this);
    }
    subscribe(subscriber) {
        return __classPrivateFieldGet(this, _ObservableSet_observable, "f").subscribe(subscriber);
    }
}
_ObservableSet_observable = new WeakMap();
export default ObservableSet;
//# sourceMappingURL=observable-set.js.map